import { useEffect, useState } from "react";
import axios from "axios";
import "../../.csscode/PopUpModal.css";
import { Label } from "reactstrap";
import Select from "react-select";
import { toast } from "sonner";
import {
  Box,
  Tabs,
  Tab,
} from '@mui/material';
import SucessModal from "../successModal/SuccessModal";
import "./../auditee/auditee.css";
import CustomLoader from "../static/CustomLoader";
import { getDropDownVal } from "../dropdownUtils";

const AuditeeHistory = ({
  selectedId,
  mode,
  onHide,
  divData,
  setAuddetails,
  auddetails,
  usedCodeList
}) => {
  const apiUrl = localStorage.getItem('apiUrl');
  const dbTokenData = localStorage.getItem('dbTokenData');
  const headers = {
    'Authorization': `Bearer ${dbTokenData}`,
    'Content-Type': 'application/json',
    'dbMaster': '',
  };
  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const [user, setUser] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  //1 tab
  const [divcode, setDivcode] = useState(null);
  const [licencenumber, setLicencenumber] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [primaryphone, setPrimaryphone] = useState("");
  const [email, setEmail] = useState("");
  const [addressline, setAddressline] = useState("");
  const [city, setCity] = useState("");
  const [dist, setDist] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [pincode, setPincode] = useState("");
  const [latd, setLatd] = useState("");
  const [longt, setLongt] = useState("");
  const [amendment, setAmendment] = useState("");

  const [licenseRenewalData, setLicenseStatus] = useState([]);
  const [hazardCategoryData, setHazardCategoryOptions] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [sectorData, setSectorData] = useState([]);
  const [workingData, setWorkingData] = useState([]);
  const [ownshirpData, setOwnshirpData] = useState([]);
  const [employeeTypeOptions, setEmpTypeData] = useState([]);

  //2nd tab
  const [formData, setFormData] = useState({});
  const requiredFields = [
    "natureOfManufacturing",
    "horsePower",
    "kilowatt",
    "fees",
    "licenseRenewalStatus",
    "licenseStrength",
    "hazardCategory",
    "coveredUnderSection",
    "sector",
    "workingStatus",
    "ownership",
    "occupieName",
    "occupierEmail",
    "occupierPhone",
    "managerName",
    "managerEmail",
    "managerPhone",
    "managementper",
  ];

  //third tab
  const [occupierData, setOccupierData] = useState([
    { firstName: "", lastName: "", contactNumber: "", email: "" },
  ]);

  //4 tab
  const [directorData, setDirectorData] = useState([
    { firstName: "", lastName: "", contactNumber: "", email: "" },
  ]);

  //5th tab
  const [employeeData, setEmployeeData] = useState([
    { employeeType: "", adultMale: "", adultFemale: "" },
  ]);

  const handleEmployeeChange = (index, field, value) => {
    const updated = [...employeeData];
    updated[index][field] = value;
    setEmployeeData(updated);
  };

  const handleDirectorChange = (index, field, value) => {
    const updated = [...directorData];
    updated[index][field] = value;
    setDirectorData(updated);
  };

  const removeDirector = (index) => {
    const updated = [...directorData];
    updated.splice(index, 1);
    setDirectorData(updated);
  };


  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };


  const removeEmployee = (index) => {
    const updated = [...employeeData];
    updated.splice(index, 1);
    setEmployeeData(updated);
  };

  const handleOccupierChange = (index, field, value) => {
    const updated = [...occupierData];
    updated[index][field] = value;
    setOccupierData(updated);
  };

  const addEmployee = () => {
    // Validate before adding
    setEmployeeData((prev) => [
      ...prev,
      { employeeType: "", adultMale: "", adultFemale: "" },
    ]);
  };

  const addOccupier = () => {
    setOccupierData((prev) => [
      ...prev,
      { firstName: "", lastName: "", contactNumber: "", email: "" },
    ]);
  };

  const addDirector = () => {
    setDirectorData((prev) => [
      ...prev,
      { firstName: "", lastName: "", contactNumber: "", email: "" },
    ]);
  };

  const removeOccupier = (index) => {
    const updated = [...occupierData];
    updated.splice(index, 1);
    setOccupierData(updated);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
  };

  useEffect(() => {
    if (mode === "U") {
      if (auddetails.code > 0) {
        const data = auddetails;
        const industry = JSON.parse(auddetails.industry);
        const occupier = auddetails.occupier;
        const directores = auddetails.manager;
        const employee = auddetails.employee;
        setId(data.id);
        setCode(data.code);
        setDivcode(data.divcode);
        setUser(data.user);
        setLicencenumber(data.licencenumber);
        setName(data.name);
        setDescription(data.description);
        setPrimaryphone(data.primaryphone);
        setEmail(data.email);
        setCity(data.city);
        setPincode(data.pincode);
        setDist(data.dist);
        setState(data.state);
        setCountry(data.country);
        setLatd(data.latd);
        setLongt(data.longt);
        setAmendment(data.amendment);
        setFormData((prev) => ({
          ...prev,
          divisionCode: industry.divisionCode,
          districtCode: industry.districtCode,
          talukCode: industry.talukCode,
          factoryRegDate: industry.factoryRegDate,
          nicCode: industry.nicCode,
          natureOfManufacturing: industry.natureOfManufacturing,
          horsePower: industry.horsePower,
          kilowatt: industry.kilowatt,
          fees: industry.fees,
          licenseRenewalStatus: industry.licenseRenewalStatus,
          licenseStrength: industry.licenseStrength,
          hazardCategory: industry.hazardCategory,
          coveredUnderSection: industry.coveredUnderSection,
          sector: industry.sector,
          workingStatus: industry.workingStatus,
          ownership: industry.ownership,
          occupieName: industry.occupieName,
          occupierEmail: industry.occupierEmail,
          occupierPhone: industry.occupierPhone,
          occupierAddress: industry.occupierAddress,
          managerName: industry.managerName,
          managerEmail: industry.managerEmail,
          managerPhone: industry.managerPhone,
          managerAddress: industry.managerAddress,
          managementper: industry.managementper,
        }));

        const parsedOccupier = JSON.parse(occupier);
        if (Array.isArray(parsedOccupier)) {
          setOccupierData(parsedOccupier);
        }

        const parsedDirectors = JSON.parse(directores);
        if (Array.isArray(parsedDirectors)) {
          setDirectorData(parsedDirectors);
        }

        const parsedEmployee = JSON.parse(employee);
        if (Array.isArray(parsedEmployee)) {
          setEmployeeData(parsedEmployee);
        }

      } else {
        const fetchAuditeesData = async () => {
          setLoading(true);
          try {
            const response = await axios.post(`${apiUrl}auditee/code/${selectedId}`, null, { headers });
            const data = response.data;
            if (data.cd === 1) {
              toast.info(data.description);
            } else {
              const industry = JSON.parse(response.data.industry);
              const occupier = response.data.occupier;
              const directores = response.data.manager;
              const employee = response.data.employee;
              setId(data.id);
              setCode(data.code);
              setDivcode(data.divcode);
              setUser(data.user);
              setLicencenumber(data.licencenumber);
              setName(data.name);
              setDescription(data.description);
              setPrimaryphone(data.primaryphone);
              setEmail(data.email);
              setCity(data.city);
              setPincode(data.pincode);
              setDist(data.dist);
              setState(data.state);
              setCountry(data.country);
              setLatd(data.latd);
              setLongt(data.longt);
              setAmendment(data.amendment);
              setFormData((prev) => ({
                ...prev,
                divisionCode: industry.divisionCode,
                districtCode: industry.districtCode,
                talukCode: industry.talukCode,
                factoryRegDate: industry.factoryRegDate,
                nicCode: industry.nicCode,
                natureOfManufacturing: industry.natureOfManufacturing,
                horsePower: industry.horsePower,
                kilowatt: industry.kilowatt,
                fees: industry.fees,
                licenseRenewalStatus: industry.licenseRenewalStatus,
                licenseStrength: industry.licenseStrength,
                hazardCategory: industry.hazardCategory,
                coveredUnderSection: industry.coveredUnderSection,
                sector: industry.sector,
                workingStatus: industry.workingStatus,
                ownership: industry.ownership,
                occupieName: industry.occupieName,
                occupierEmail: industry.occupierEmail,
                occupierPhone: industry.occupierPhone,
                occupierAddress: industry.occupierAddress,
                managerName: industry.managerName,
                managerEmail: industry.managerEmail,
                managerPhone: industry.managerPhone,
                managerAddress: industry.managerAddress,
                managementper: industry.managementper,
              }));

              const parsedOccupier = JSON.parse(occupier);
              if (Array.isArray(parsedOccupier)) {
                setOccupierData(parsedOccupier);
              }

              const parsedDirectors = JSON.parse(directores);
              if (Array.isArray(parsedDirectors)) {
                setDirectorData(parsedDirectors);
              }

              const parsedEmployee = JSON.parse(employee);
              if (Array.isArray(parsedEmployee)) {
                setEmployeeData(parsedEmployee);
              }
            }
          } catch (error) {
            toast.error("Failed to fetch details.");
          } finally {
            setLoading(false);
          }
        };
        fetchAuditeesData();
      }
    }
  }, [mode]);



  useEffect(() => {
    const fetchEmployeeTypeOptions = () => {
      try {
        const response = getDropDownVal("EMPTP");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setEmpTypeData(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    const fetchOwnShirpOptions = () => {
      try {
        const response = getDropDownVal("OWN");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setOwnshirpData(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    const fetchWorkingOptions = () => {
      try {
        const response = getDropDownVal("FWST");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setWorkingData(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    const fetchSectorOptions = () => {
      try {
        const response = getDropDownVal("SST");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setSectorData(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    const fetchSectionOptions = () => {
      try {
        const response = getDropDownVal("SCT");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setSectionData(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    const fetchLicenceStatusOptions = () => {
      try {
        const response = getDropDownVal("LRST");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setLicenseStatus(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    const fetchHazardCategoryOptions = () => {
      try {
        const response = getDropDownVal("HCAT");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setHazardCategoryOptions(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    // Call all dropdown functions
    fetchEmployeeTypeOptions();
    fetchOwnShirpOptions();
    fetchWorkingOptions();
    fetchSectorOptions();
    fetchSectionOptions();
    fetchLicenceStatusOptions();
    fetchHazardCategoryOptions();
  }, []);

  function clearFields() {
    setErrors({});
    setId("");
    setCode("");
    setDivcode(null);
    setLicencenumber("");
    setName("");
    setDescription("");
    setPrimaryphone("");
    setEmail("");
    setAddressline("");
    setCity("");
    setDist("");
    setState("");
    setCountry("");
    setPincode("");
    setLatd("");
    setLongt("");

    // Second tab
    setFormData({});

    // Third tab (Occupiers)
    setOccupierData([
      { firstName: "", lastName: "", contactNumber: "", email: "" },
    ]);

    // Fourth tab (Directors)
    setDirectorData([
      { firstName: "", lastName: "", contactNumber: "", email: "" },
    ]);

    // Fifth tab (Employees)
    setEmployeeData([{ employeeType: "", adultMale: "", adultFemale: "" }]);
  }

  const handleFocus = (field) => {
    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
  };

  const handleAdd = async () => {
    const userdetails = JSON.parse(localStorage.getItem('user'));
    const payLoad = {
      divcode: divcode,
      licencenumber: licencenumber,
      name: name,
      description: description,
      primaryphone: primaryphone,
      email: email,
      addressline: addressline,
      city: city,
      dist: dist,
      state: state,
      country: country,
      pincode: pincode,
      latd: latd,
      longt: longt,
      industry: JSON.stringify(formData),
      occupier: JSON.stringify(occupierData),
      manager: JSON.stringify(directorData),
      employee: JSON.stringify(employeeData),
      amendment: amendment,
      user: user
    };

    try {
      const response = await axios.post(`${apiUrl}auditee`, payLoad, { headers, });

      if (response.data.cd === 1) {
        setSucessMessage(response.data.description);
        setTitle("⚠️ Failed");
      } else {
        setSucessMessage(response.data.description);
        setTitle("✔️ Success");
      }
      setShowSucessModal(true);
    } catch (error) {
      toast.error("Something went wrong while adding data.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    const userdetails = JSON.parse(localStorage.getItem('user'));
    const payLoad = {
      id: id,
      code: code,
      divcode: divcode,
      licencenumber: licencenumber,
      name: name,
      description: description,
      primaryphone: primaryphone,
      email: email,
      addressline: addressline,
      city: city,
      dist: dist,
      state: state,
      country: country,
      pincode: pincode,
      latd: latd,
      longt: longt,
      industry: JSON.stringify(formData),
      occupier: JSON.stringify(occupierData),
      manager: JSON.stringify(directorData),
      employee: JSON.stringify(employeeData),
      amendment: amendment,
      user: user
    };

    setAuddetails(payLoad);
    onHide(payLoad);
  };

  const handlesubmit = async () => {
    setLoading(true);

    const firstTabValid = validateFirstTabForm();


    if (!firstTabValid) {
      setActiveTab(0);
      setLoading(false);
      toast.warning("Please fill all requied filed...");
      return;
    }


    if (mode === "A") {
      await handleAdd();
    } else {
      await handleUpdate();
    }
  };

  const validateFirstTabForm = () => {
    let newErrors = {};

    if (!divcode) newErrors.divcode = "Division code is required.";
    if (!licencenumber.trim())
      newErrors.licencenumber = "Licence number is required.";
    if (!name.trim()) newErrors.name = "Name is required.";
    if (!pincode) newErrors.pincode = "Pincode is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateSecondTabForm = () => {
    const newErrors = {};

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = "This field is required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      fontWeight: "normal",
      color: "#999", // You can set a custom color if needed
    }),
    control: (provided) => ({
      ...provided,
      fontWeight: "normal",
      minHeight: "calc(1.5em + .75rem + 2px)", // Ensures it matches the bootstrap input height
    }),
  };

  const fetchPincodeDetails = async (enteredPincode) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://api.postalpincode.in/pincode/${enteredPincode}`
      );
      if (
        response.data &&
        response.data.length > 0 &&
        response.data[0].Status === "Success"
      ) {
        const postOffice = response.data[0].PostOffice[0];
        setCity(postOffice.Block || "");
        setDist(postOffice.District || "");
        setState(postOffice.State || "");
        setCountry(postOffice.Country || "");
        setLoading(false);
      } else {
        toast.error("Invalid pincode or details not found.");
        setCity("");
        setDist("");
        setState("");
        setCountry("");
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to fetch location from pincode.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  if (mode === "A") {
    /*Handle Update */
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />
        <div className="auditeemodel-histdiv">
          <Box sx={{ width: '100%' }}>
            {/* TAB HEADER */}
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                backgroundColor: '#f1f5f9', // 👈 light grey / change as you like
                borderRadius: '4px 4px 0 0',
                '& .MuiTab-root': {
                  color: '#444',
                  fontWeight: 600,
                  fontSize: '14px',
                  textTransform: 'none',
                },
                '& .Mui-selected': {
                  color: '#2962ff', // 👈 selected tab text color
                  fontWeight: 700,
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: '#2962ff', // 👈 indicator underline color
                  height: '4px',
                  borderRadius: '4px'
                },
              }}
            >
              <Tab label="Register New Factory" />
              <Tab label="Factory Registration Details" />
              <Tab label="Company Director Details" />
              <Tab label="Add Employee Details" />
            </Tabs>
            <Box sx={{ borderBottom: '2px solid #2962ff', mb: 2 }} />
          </Box>

          {activeTab === 0 && (
            <div className="auditeemodel-form-section">
              {/* Row 1 */}
              <div className="row">
                <div className="col-md-12 mb-3">
                  <Label>Employee/User</Label>
                  <Select
                    isDisabled={true}
                    options={usedCodeList}
                    value={usedCodeList.find((opt) => opt.value === user)}
                    onChange={(selected) => setUser(selected?.value)}
                    styles={customStyles}
                    placeholder="Select User Data"
                    required
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Division <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isClearable
                    options={divData}
                    value={divData.find((opt) => opt.value === divcode)}
                    onChange={(selected) => setDivcode(selected?.value)}
                    styles={customStyles}
                    placeholder="Select Division"
                    required
                  />
                  {errors.divcode && (
                    <small className="text-danger">{errors.divcode}</small>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Label>
                    Licence Number <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.licencenumber ? "is-invalid" : ""
                      }`}
                    type="text"
                    value={licencenumber}
                    onChange={(e) => setLicencenumber(e.target.value)}
                  />
                  {errors.licencenumber && (
                    <small className="text-danger">
                      {errors.licencenumber}
                    </small>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Label>
                    Name <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.name ? "is-invalid" : ""
                      }`}
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onFocus={() => handleFocus("name")}
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name}</small>
                  )}
                </div>
              </div>

              {/* Row 2 */}
              <div className="row">
              

                <div className="col-md-4 mb-3">
                  <Label>Primary Phone</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={primaryphone}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) setPrimaryphone(value);
                    }}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <Label>Email</Label>
                  <input
                    className="form-control"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              {/* Row 3 */}
              <div className="row">
                <div className="col-md-4 mb-3">
                  <Label>Address Line</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={addressline}
                    onChange={(e) => setAddressline(e.target.value)}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <Label>
                    Pincode <span className="text-danger">*</span>
                  </Label>
                  <input
                    type="text"
                    className={`form-control ${errors.pincode ? "is-invalid" : ""
                      }`}
                    value={pincode}
                    maxLength={6}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setPincode(value);
                      if (value.length === 6) fetchPincodeDetails(value);
                    }}
                    onFocus={() => handleFocus("pincode")}
                  />
                  {errors.pincode && (
                    <small className="text-danger">{errors.pincode}</small>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Label>City</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={city}
                    readOnly
                  />
                </div>
              </div>

              {/* Row 4 */}
              <div className="row">


                <div className="col-md-4 mb-3">
                  <Label>State</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={state}
                    readOnly
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <Label>Country</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={country}
                    readOnly
                  />
                </div>
              </div>

              {/* Row 5 */}
              <div className="row">
                <div className="col-md-4 mb-3">
                  <Label>Latitude</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={latd}
                    onChange={(e) => setLatd(e.target.value)}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <Label>Longitude</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={longt}
                    onChange={(e) => setLongt(e.target.value)}
                  />
                </div>


              </div>
            </div>
          )}

          {activeTab === 1 && (
            <div className="auditeemodel-form-section">
              <div className="row">


                {/* Row 2 */}
                <div className="col-md-4 mb-3">
                  <Label>
                    Factory Registration Date{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.factoryRegDate ? "is-invalid" : ""
                      }`}
                    type="date"
                    name="factoryRegDate"
                    value={formData.factoryRegDate}
                    onChange={handleInputChange}
                  />
                  {errors.factoryRegDate && (
                    <small className="text-danger">
                      {errors.factoryRegDate}
                    </small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    NIC code of the Factory{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.nicCode ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="nicCode"
                    value={formData.nicCode}
                    onChange={handleInputChange}
                  />
                  {errors.nicCode && (
                    <small className="text-danger">{errors.nicCode}</small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Nature of Manufacturing{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.natureOfManufacturing ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="natureOfManufacturing"
                    value={formData.natureOfManufacturing}
                    onChange={handleInputChange}
                  />
                  {errors.natureOfManufacturing && (
                    <small className="text-danger">
                      {errors.natureOfManufacturing}
                    </small>
                  )}
                </div>

                {/* Row 3 */}
                <div className="col-md-4 mb-3">
                  <Label>
                    Horse Power (HP) <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.horsePower ? "is-invalid" : ""
                      }`}
                    type="number"
                    name="horsePower"
                    value={formData.horsePower}
                    onChange={handleInputChange}
                  />
                  {errors.horsePower && (
                    <small className="text-danger">{errors.horsePower}</small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Kilowatt (KW) <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.kilowatt ? "is-invalid" : ""
                      }`}
                    type="number"
                    name="kilowatt"
                    value={formData.kilowatt}
                    onChange={handleInputChange}
                  />
                  {errors.kilowatt && (
                    <small className="text-danger">{errors.kilowatt}</small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Fees <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.fees ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="fees"
                    value={formData.fees}
                    onChange={handleInputChange}
                  />
                  {errors.fees && (
                    <small className="text-danger">{errors.fees}</small>
                  )}
                </div>

                {/* Row 4 */}
                <div className="col-md-4 mb-3">
                  <Label>
                    Factory License Renewal Status <span className="text-danger">*</span>
                  </Label>

                  <Select
                    isClearable
                    options={licenseRenewalData}
                    value={licenseRenewalData.find(
                      (opt) => opt.value === formData.licenseRenewalStatus
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "licenseRenewalStatus",
                          value: selected?.value || "",
                        },
                      })
                    }
                    styles={customStyles}
                    placeholder="Select Status"
                  />
                  {errors.licenseRenewalStatus && (
                    <small className="text-danger">
                      {errors.licenseRenewalStatus}
                    </small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Factory License Strength{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.licenseStrength ? "is-invalid" : ""
                      }`}
                    type="number"
                    name="licenseStrength"
                    value={formData.licenseStrength}
                    onChange={handleInputChange}
                  />
                  {errors.licenseStrength && (
                    <small className="text-danger">
                      {errors.licenseStrength}
                    </small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Factory Hazard Category{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isClearable
                    options={hazardCategoryData}
                    value={hazardCategoryData.find(
                      (opt) => opt.value === formData.hazardCategory
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "hazardCategory",
                          value: selected?.value || "",
                        },
                      })
                    }
                    styles={customStyles}
                    placeholder="Select Category"
                  />
                  {errors.hazardCategory && (
                    <small className="text-danger">
                      {errors.hazardCategory}
                    </small>
                  )}
                </div>

                {/* Row 5 */}
                <div className="col-md-4 mb-3">
                  <Label>
                    Covered under Section{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isClearable
                    options={sectionData}
                    value={sectionData.find(
                      (opt) => opt.value === formData.coveredUnderSection
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "coveredUnderSection",
                          value: selected?.value || "",
                        },
                      })
                    }
                    styles={customStyles}
                    placeholder="Select Section"
                  />

                  {errors.coveredUnderSection && (
                    <small className="text-danger">
                      {errors.coveredUnderSection}
                    </small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Sector <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isClearable
                    options={sectorData}
                    value={sectorData.find(
                      (opt) => opt.value === formData.sector
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "sector",
                          value: selected?.value || "",
                        },
                      })
                    }
                    styles={customStyles}
                    placeholder="Select Sector"
                  />

                  {errors.sector && (
                    <small className="text-danger">{errors.sector}</small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Factory Working Status{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isClearable
                    options={workingData}
                    value={workingData.find(
                      (opt) => opt.value === formData.workingStatus
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "workingStatus",
                          value: selected?.value || "",
                        },
                      })
                    }
                    styles={customStyles}
                    placeholder="Select Working status"
                  />

                  {errors.workingStatus && (
                    <small className="text-danger">
                      {errors.workingStatus}
                    </small>
                  )}
                </div>

                {/* Row 6 */}
                <div className="col-md-12 mb-3">
                  <Label>
                    Ownership <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isClearable
                    options={ownshirpData}
                    value={ownshirpData.find(
                      (opt) => opt.value === formData.ownership
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "ownership",
                          value: selected?.value || "",
                        },
                      })
                    }
                    styles={customStyles}
                    placeholder="Select Ownership"
                  />

                  {errors.ownership && (
                    <small className="text-danger">{errors.ownership}</small>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <Label>
                    Occupier Name <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.occupieName ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="occupieName"
                    value={formData.occupieName}
                    onChange={handleInputChange}
                  />
                  {errors.occupieName && (
                    <small className="text-danger">
                      {errors.occupieName}
                    </small>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <Label>
                    Occupier Email <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.occupierEmail ? "is-invalid" : ""
                      }`}
                    type="email"
                    name="occupierEmail"
                    value={formData.occupierEmail}
                    onChange={handleInputChange}
                  />
                  {errors.occupierEmail && (
                    <small className="text-danger">
                      {errors.occupierEmail}
                    </small>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <Label>
                    Occupier Phone <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.occupierPhone ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="occupierPhone"
                    value={formData.occupierPhone}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        handleInputChange({
                          target: { name: "occupierPhone", value },
                        });
                      }
                    }}
                  />
                  {errors.occupierPhone && (
                    <small className="text-danger">
                      {errors.occupierPhone}
                    </small>
                  )}
                </div>

                {/* Row 7 */}
                <div className="col-md-3 mb-3">
                  <Label>
                    Occupier Address <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.occupierAddress ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="occupierAddress"
                    value={formData.occupierAddress}
                    onChange={handleInputChange}
                  />
                  {errors.occupierAddress && (
                    <small className="text-danger">
                      {errors.occupierAddress}
                    </small>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <Label>
                    Manager Name <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.managerName ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="managerName"
                    value={formData.managerName}
                    onChange={handleInputChange}
                  />
                  {errors.managerName && (
                    <small className="text-danger">
                      {errors.managerName}
                    </small>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <Label>
                    Manager Email <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.managerEmail ? "is-invalid" : ""
                      }`}
                    type="email"
                    name="managerEmail"
                    value={formData.managerEmail}
                    onChange={handleInputChange}
                  />
                  {errors.managerEmail && (
                    <small className="text-danger">
                      {errors.managerEmail}
                    </small>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <Label>
                    Manager Phone <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.managerPhone ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="managerPhone"
                    value={formData.managerPhone}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        handleInputChange({
                          target: { name: "managerPhone", value },
                        });
                      }
                    }}
                  />
                  {errors.managerPhone && (
                    <small className="text-danger">
                      {errors.managerPhone}
                    </small>
                  )}
                </div>

                {/* Row 8 */}
                <div className="col-md-3 mb-3">
                  <Label>
                    Manager Address <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.managerAddress ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="managerAddress"
                    value={formData.managerAddress}
                    onChange={handleInputChange}
                  />
                  {errors.managerAddress && (
                    <small className="text-danger">
                      {errors.managerAddress}
                    </small>
                  )}
                </div>
                <div className="col-md-12 mb-3">
                  <Label>
                    Management Person During Inspection <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.managementper ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="managementper"
                    value={formData.managementper}
                    onChange={handleInputChange}
                  />
                  {errors.managementper && (
                    <small className="text-danger">
                      {errors.managementper}
                    </small>
                  )}
                </div>
              </div>
            </div>
          )}

          {activeTab === 2 && (
            <div className="auditeemodel-form-section">
              {directorData.map((director, index) => (
                <div key={director.id} className="border rounded mb-3 p-3">
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label>
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={director.firstName}
                        onChange={(e) =>
                          handleDirectorChange(
                            index,
                            "firstName",
                            e.target.value
                          )
                        }
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={director.lastName}
                        onChange={(e) =>
                          handleDirectorChange(
                            index,
                            "lastName",
                            e.target.value
                          )
                        }
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-2">
                      <label>
                        Contact Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={10}
                        value={director.contactNumber}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          if (value.length <= 10) {
                            handleDirectorChange(
                              index,
                              "contactNumber",
                              value
                            );
                          }
                        }}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>
                        Email Address <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        value={director.email}
                        onChange={(e) =>
                          handleDirectorChange(index, "email", e.target.value)
                        }
                        required
                      />
                    </div>
                  </div>

                  <div className="text-end">
                    {directorData.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger btn-sm mt-2"
                        onClick={() => removeDirector(index)}
                      >
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              ))}

              <div className="text-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {

                    addDirector();
                  }}
                >
                  Add
                </button>
              </div>
            </div>
          )}

          {activeTab === 3 && (
            <div className="auditeemodel-form-section">
              {employeeData.map((employee, index) => (
                <div
                  key={employee.id}
                  className="row border rounded p-3 mb-3"
                >
                  <div className="col-md-4 mb-2">
                    <label>
                      Employee Type <span className="text-danger">*</span>
                    </label>
                    <Select
                      isClearable
                      options={employeeTypeOptions}
                      value={employeeTypeOptions.find(
                        (opt) => opt.value === employee.employeeType
                      )}
                      onChange={(selected) =>
                        handleEmployeeChange(
                          index,
                          "employeeType",
                          selected?.value
                        )
                      }
                      placeholder="Select Employee Type"
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label>
                      Adult Male Count <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      min="0"
                      value={employee.adultMale}
                      onChange={(e) =>
                        handleEmployeeChange(
                          index,
                          "adultMale",
                          e.target.value
                        )
                      }
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label>
                      Adult Female Count{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      min="0"
                      value={employee.adultFemale}
                      onChange={(e) =>
                        handleEmployeeChange(
                          index,
                          "adultFemale",
                          e.target.value
                        )
                      }
                    />
                  </div>

                  <div className="col-12 text-end">
                    {employeeData.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger btn-sm mt-2"
                        onClick={() => removeEmployee(index)}
                      >
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              ))}

              <div className="text-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={addEmployee}
                >
                  Add Employee
                </button>
              </div>
            </div>
          )}



          <div className="bottombtn">
            <button
              className="btn btn-success"
              disabled={loading}
              onClick={handlesubmit}
            >
              Save
            </button>
          </div>

          {loading && (
            <CustomLoader />
          )}
        </div>
      </>
    );
  } else if (mode === "U") {
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />

        <div className="auditeemodel-histdiv">
          <Box sx={{ width: '100%' }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                backgroundColor: '#f1f5f9', // 👈 light grey / change as you like
                borderRadius: '4px 4px 0 0',
                '& .MuiTab-root': {
                  color: '#444',
                  fontWeight: 600,
                  fontSize: '14px',
                  textTransform: 'none',
                },
                '& .Mui-selected': {
                  color: '#2962ff', // 👈 selected tab text color
                  fontWeight: 700,
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: '#2962ff', // 👈 indicator underline color
                  height: '4px',
                  borderRadius: '4px'
                },
              }}
            >
              <Tab label="Basic Details" />
              <Tab label="Factory Registration Details" />
              <Tab label="Company Director Details" />
              <Tab label="Add Employee Details" />

            </Tabs>
            <Box sx={{ borderBottom: '2px solid #2962ff', mb: 2 }} />
          </Box>

          {activeTab === 0 && (
            <div className="auditeemodel-form-section">
              {/* Row 1 */}
              <div className="row">
                <div className="col-md-12 mb-3">
                  <Label>Employee/User</Label>
                  <Select
                    isClearable
                    isDisabled={true}
                    options={usedCodeList}
                    value={usedCodeList.find((opt) => opt.value === user)}
                    onChange={(selected) => setUser(selected?.value)}
                    styles={customStyles}
                    placeholder="Select User Data"
                    required
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Division <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isClearable
                    options={divData}
                    value={divData.find((opt) => opt.value === divcode)}
                    onChange={(selected) => setDivcode(selected?.value)}
                    styles={customStyles}
                    placeholder="Select Division"
                  />
                  {errors.divcode && (
                    <small className="text-danger">{errors.divcode}</small>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Label>
                    Licence Number <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.licencenumber ? "is-invalid" : ""
                      }`}
                    type="text"
                    readOnly
                    value={licencenumber}
                    onChange={(e) => setLicencenumber(e.target.value)}
                  />
                  {errors.licencenumber && (
                    <small className="text-danger">
                      {errors.licencenumber}
                    </small>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Label>
                    Name <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.name ? "is-invalid" : ""
                      }`}
                    type="text"
                    readOnly
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onFocus={() => handleFocus("name")}
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name}</small>
                  )}
                </div>
              </div>

              {/* Row 2 */}
              <div className="row">


                <div className="col-md-4 mb-3">
                  <Label>Primary Phone</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={primaryphone}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) setPrimaryphone(value);
                    }}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <Label>Email</Label>
                  <input
                    className="form-control"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              {/* Row 3 */}
              <div className="row">
                <div className="col-md-4 mb-3">
                  <Label>Address Line</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={addressline}
                    onChange={(e) => setAddressline(e.target.value)}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <Label>
                    Pincode <span className="text-danger">*</span>
                  </Label>
                  <input
                    type="text"
                    className={`form-control ${errors.pincode ? "is-invalid" : ""
                      }`}
                    value={pincode}
                    maxLength={6}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setPincode(value);
                      if (value.length === 6) fetchPincodeDetails(value);
                    }}
                    onFocus={() => handleFocus("pincode")}
                  />
                  {errors.pincode && (
                    <small className="text-danger">{errors.pincode}</small>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <Label>City</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={city}
                    readOnly
                  />
                </div>
              </div>

              {/* Row 4 */}
              <div className="row">
                <div className="col-md-4 mb-3">
                  <Label>District</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={dist}
                    readOnly
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <Label>State</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={state}
                    readOnly
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <Label>Country</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={country}
                    readOnly
                  />
                </div>
              </div>

              {/* Row 5 */}
              <div className="row">
                <div className="col-md-4 mb-3">
                  <Label>Latitude</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={latd}
                    onChange={(e) => setLatd(e.target.value)}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <Label>Longitude</Label>
                  <input
                    className="form-control"
                    type="text"
                    value={longt}
                    onChange={(e) => setLongt(e.target.value)}
                  />
                </div>


              </div>
            </div>
          )}

          {activeTab === 1 && (
            <div className="auditeemodel-form-section">
              <div className="row">

                {/* Row 2 */}
                <div className="col-md-4 mb-3">
                  <Label>
                    Factory Registration Date{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.factoryRegDate ? "is-invalid" : ""
                      }`}
                    type="date"
                    name="factoryRegDate"
                    value={formData.factoryRegDate}
                    onChange={handleInputChange}
                  />
                  {errors.factoryRegDate && (
                    <small className="text-danger">
                      {errors.factoryRegDate}
                    </small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    NIC code of the Factory{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.nicCode ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="nicCode"
                    value={formData.nicCode}
                    onChange={handleInputChange}
                  />
                  {errors.nicCode && (
                    <small className="text-danger">{errors.nicCode}</small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Nature of Manufacturing{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.natureOfManufacturing ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="natureOfManufacturing"
                    value={formData.natureOfManufacturing}
                    onChange={handleInputChange}
                  />
                  {errors.natureOfManufacturing && (
                    <small className="text-danger">
                      {errors.natureOfManufacturing}
                    </small>
                  )}
                </div>

                {/* Row 3 */}
                <div className="col-md-4 mb-3">
                  <Label>
                    Horse Power (HP) <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.horsePower ? "is-invalid" : ""
                      }`}
                    type="number"
                    name="horsePower"
                    value={formData.horsePower}
                    onChange={handleInputChange}
                  />
                  {errors.horsePower && (
                    <small className="text-danger">{errors.horsePower}</small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Kilowatt (KW) <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.kilowatt ? "is-invalid" : ""
                      }`}
                    type="number"
                    name="kilowatt"
                    value={formData.kilowatt}
                    onChange={handleInputChange}
                  />
                  {errors.kilowatt && (
                    <small className="text-danger">{errors.kilowatt}</small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Fees <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.fees ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="fees"
                    value={formData.fees}
                    onChange={handleInputChange}
                  />
                  {errors.fees && (
                    <small className="text-danger">{errors.fees}</small>
                  )}
                </div>

                {/* Row 4 */}
                <div className="col-md-4 mb-3">
                  <Label>
                    Factory License Renewal Status <span className="text-danger">*</span>
                  </Label>

                  <Select
                    isClearable
                    options={licenseRenewalData}
                    value={licenseRenewalData.find(
                      (opt) => opt.value === formData.licenseRenewalStatus
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "licenseRenewalStatus",
                          value: selected?.value || "",
                        },
                      })
                    }
                    styles={customStyles}
                    placeholder="Select Status"
                  />
                  {errors.licenseRenewalStatus && (
                    <small className="text-danger">
                      {errors.licenseRenewalStatus}
                    </small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Factory License Strength{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.licenseStrength ? "is-invalid" : ""
                      }`}
                    type="number"
                    name="licenseStrength"
                    value={formData.licenseStrength}
                    onChange={handleInputChange}
                  />
                  {errors.licenseStrength && (
                    <small className="text-danger">
                      {errors.licenseStrength}
                    </small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Factory Hazard Category{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isClearable
                    options={hazardCategoryData}
                    value={hazardCategoryData.find(
                      (opt) => opt.value === formData.hazardCategory
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "hazardCategory",
                          value: selected?.value || "",
                        },
                      })
                    }
                    styles={customStyles}
                    placeholder="Select Category"
                  />
                  {errors.hazardCategory && (
                    <small className="text-danger">
                      {errors.hazardCategory}
                    </small>
                  )}
                </div>

                {/* Row 5 */}
                <div className="col-md-4 mb-3">
                  <Label>
                    Covered under Section{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isClearable
                    options={sectionData}
                    value={sectionData.find(
                      (opt) => opt.value === formData.coveredUnderSection
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "coveredUnderSection",
                          value: selected?.value || "",
                        },
                      })
                    }
                    styles={customStyles}
                    placeholder="Select Section"
                  />

                  {errors.coveredUnderSection && (
                    <small className="text-danger">
                      {errors.coveredUnderSection}
                    </small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Sector <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isClearable
                    options={sectorData}
                    value={sectorData.find(
                      (opt) => opt.value === formData.sector
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "sector",
                          value: selected?.value || "",
                        },
                      })
                    }
                    styles={customStyles}
                    placeholder="Select Sector"
                  />

                  {errors.sector && (
                    <small className="text-danger">{errors.sector}</small>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <Label>
                    Factory Working Status{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isClearable
                    options={workingData}
                    value={workingData.find(
                      (opt) => opt.value === formData.workingStatus
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "workingStatus",
                          value: selected?.value || "",
                        },
                      })
                    }
                    styles={customStyles}
                    placeholder="Select Working status"
                  />

                  {errors.workingStatus && (
                    <small className="text-danger">
                      {errors.workingStatus}
                    </small>
                  )}
                </div>

                {/* Row 6 */}
                <div className="col-md-12 mb-3">
                  <Label>
                    Ownership <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isClearable
                    options={ownshirpData}
                    value={ownshirpData.find(
                      (opt) => opt.value === formData.ownership
                    )}
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "ownership",
                          value: selected?.value || "",
                        },
                      })
                    }
                    styles={customStyles}
                    placeholder="Select Ownership"
                  />

                  {errors.ownership && (
                    <small className="text-danger">{errors.ownership}</small>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <Label>
                    Occupier Name <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.occupieName ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="occupieName"
                    value={formData.occupieName}
                    onChange={handleInputChange}
                  />
                  {errors.occupieName && (
                    <small className="text-danger">
                      {errors.occupieName}
                    </small>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <Label>
                    Occupier Email <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.occupierEmail ? "is-invalid" : ""
                      }`}
                    type="email"
                    name="occupierEmail"
                    value={formData.occupierEmail}
                    onChange={handleInputChange}
                  />
                  {errors.occupierEmail && (
                    <small className="text-danger">
                      {errors.occupierEmail}
                    </small>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <Label>
                    Occupier Phone <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.occupierPhone ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="occupierPhone"
                    value={formData.occupierPhone}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        handleInputChange({
                          target: { name: "occupierPhone", value },
                        });
                      }
                    }}
                  />
                  {errors.occupierPhone && (
                    <small className="text-danger">
                      {errors.occupierPhone}
                    </small>
                  )}
                </div>

                {/* Row 7 */}
                <div className="col-md-3 mb-3">
                  <Label>
                    Occupier Address <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.occupierAddress ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="occupierAddress"
                    value={formData.occupierAddress}
                    onChange={handleInputChange}
                  />
                  {errors.occupierAddress && (
                    <small className="text-danger">
                      {errors.occupierAddress}
                    </small>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <Label>
                    Manager Name <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.managerName ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="managerName"
                    value={formData.managerName}
                    onChange={handleInputChange}
                  />
                  {errors.managerName && (
                    <small className="text-danger">
                      {errors.managerName}
                    </small>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <Label>
                    Manager Email <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.managerEmail ? "is-invalid" : ""
                      }`}
                    type="email"
                    name="managerEmail"
                    value={formData.managerEmail}
                    onChange={handleInputChange}
                  />
                  {errors.managerEmail && (
                    <small className="text-danger">
                      {errors.managerEmail}
                    </small>
                  )}
                </div>
                <div className="col-md-3 mb-3">
                  <Label>
                    Manager Phone <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.managerPhone ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="managerPhone"
                    value={formData.managerPhone}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 10) {
                        handleInputChange({
                          target: { name: "managerPhone", value },
                        });
                      }
                    }}
                  />
                  {errors.managerPhone && (
                    <small className="text-danger">
                      {errors.managerPhone}
                    </small>
                  )}
                </div>

                {/* Row 8 */}
                <div className="col-md-3 mb-3">
                  <Label>
                    Manager Address <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.managerAddress ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="managerAddress"
                    value={formData.managerAddress}
                    onChange={handleInputChange}
                  />
                  {errors.managerAddress && (
                    <small className="text-danger">
                      {errors.managerAddress}
                    </small>
                  )}
                </div>
                <div className="col-md-12 mb-3">
                  <Label>
                    Management Person During Inspection <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.managementper ? "is-invalid" : ""
                      }`}
                    type="text"
                    name="managementper"
                    value={formData.managementper}
                    onChange={handleInputChange}
                  />
                  {errors.managementper && (
                    <small className="text-danger">
                      {errors.managementper}
                    </small>
                  )}
                </div>
              </div>
            </div>
          )}

          {activeTab === 2 && (
            <div className="auditeemodel-form-section">
              {directorData.map((director, index) => (
                <div key={director.id} className="border rounded mb-3 p-3">
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label>
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={director.firstName}
                        onChange={(e) =>
                          handleDirectorChange(
                            index,
                            "firstName",
                            e.target.value
                          )
                        }
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={director.lastName}
                        onChange={(e) =>
                          handleDirectorChange(
                            index,
                            "lastName",
                            e.target.value
                          )
                        }
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-2">
                      <label>
                        Contact Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={10}
                        value={director.contactNumber}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          if (value.length <= 10) {
                            handleDirectorChange(
                              index,
                              "contactNumber",
                              value
                            );
                          }
                        }}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>
                        Email Address <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        value={director.email}
                        onChange={(e) =>
                          handleDirectorChange(index, "email", e.target.value)
                        }
                        required
                      />
                    </div>
                  </div>

                  <div className="text-end">
                    {directorData.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger btn-sm mt-2"
                        onClick={() => removeDirector(index)}
                      >
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              ))}

              <div className="text-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    addDirector();
                  }}
                >
                  Add
                </button>
              </div>
            </div>
          )}

          {activeTab === 3 && (
            <div className="auditeemodel-form-section">
              {employeeData.map((employee, index) => (
                <div
                  key={employee.id}
                  className="row border rounded p-3 mb-3"
                >
                  <div className="col-md-4 mb-2">
                    <label>
                      Employee Type <span className="text-danger">*</span>
                    </label>
                    <Select
                      isClearable
                      options={employeeTypeOptions}
                      value={employeeTypeOptions.find(
                        (opt) => opt.value === employee.employeeType
                      )}
                      onChange={(selected) =>
                        handleEmployeeChange(
                          index,
                          "employeeType",
                          selected?.value
                        )
                      }
                      placeholder="Select Employee Type"
                    />
                  </div>
                  <div className="col-md-4 mb-2">
                    <label>
                      Adult Male Count <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      min="0"
                      value={employee.adultMale}
                      onChange={(e) =>
                        handleEmployeeChange(
                          index,
                          "adultMale",
                          e.target.value
                        )
                      }
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label>
                      Adult Female Count{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      min="0"
                      value={employee.adultFemale}
                      onChange={(e) =>
                        handleEmployeeChange(
                          index,
                          "adultFemale",
                          e.target.value
                        )
                      }
                    />
                  </div>

                  <div className="col-12 text-end">
                    {employeeData.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger btn-sm mt-2"
                        onClick={() => removeEmployee(index)}
                      >
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              ))}

              <div className="text-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={addEmployee}
                >
                  Add Employee
                </button>
              </div>
            </div>
          )}

          <div className="bottombtn">
            <button
              className="btn btn-success"
              disabled={loading}
              onClick={handlesubmit}
            >
              Save
            </button>
            <button className="btn btn-danger" onClick={onHide}>
              Close
            </button>
          </div>
          {loading && (
            <CustomLoader />
          )}
        </div>
      </>
    );
  }
};

export default AuditeeHistory;
